import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac759da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process-result" }
const _hoisted_2 = { class: "result-container" }
const _hoisted_3 = { class: "report-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "section-title" }, "上报信息", -1))
const _hoisted_5 = { class: "info-content" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "上报时间：", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "上报用户：", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "上报采集订单号：", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "info-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "上报标的号：", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "上报登记号：", -1))
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "info-item info-note" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label orange-bar" }, "情况备注：", -1))
const _hoisted_23 = { class: "note-content" }
const _hoisted_24 = {
  key: 0,
  class: "info-item"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "语音记录：", -1))
const _hoisted_26 = { class: "media-list" }
const _hoisted_27 = { class: "audio-player" }
const _hoisted_28 = { class: "progress-container" }
const _hoisted_29 = { class: "progress-bar-wrapper" }
const _hoisted_30 = { class: "time-display" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "info-item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label orange-bar" }, "联系电话：", -1))
const _hoisted_35 = { class: "value" }
const _hoisted_36 = { class: "process-info" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "section-title" }, "处理结果", -1))
const _hoisted_38 = { class: "info-content" }
const _hoisted_39 = { class: "info-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label orange-bar" }, "投保对比结果：", -1))
const _hoisted_41 = { class: "value result-text" }
const _hoisted_42 = {
  key: 0,
  class: "duplicate-info"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "label orange-bar" }, "重复标的信息：")
], -1))
const _hoisted_44 = { class: "info-item indent" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "投保单号：", -1))
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "info-item indent" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "标的号：", -1))
const _hoisted_49 = { class: "value" }
const _hoisted_50 = { class: "info-item indent" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "登记号：", -1))
const _hoisted_52 = { class: "value" }
const _hoisted_53 = { class: "info-item indent" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "相似度：", -1))
const _hoisted_55 = { class: "value similarity" }
const _hoisted_56 = { class: "info-item" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label orange-bar" }, "处理结果说明：", -1))
const _hoisted_58 = { class: "process-timeline" }

import { ref, onBeforeUnmount, onBeforeMount } from 'vue'
import { ElMessage } from 'element-plus'
import BenzAMRRecorder from 'benz-amr-recorder'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessResultDialog',
  props: {
  reportInfo: {
    type: Object,
    required: true
  },
  processResult: {
    type: Object,
    required: true,
    default: () => ({
      compareResult: '',
      duplicateInfo: null,
      description: ''
    })
  },
  readonly: {
    type: Boolean,
    default: false
  }
},
  emits: ['confirm'],
  setup(__props, { emit }) {

const props = __props;

const localProcessResult = ref({ ...props.processResult });
const amrPlayer = ref<any>(null)
const currentTime = ref('00:00')
const playingIndex = ref<number | null>(null)
const isPaused = ref(false)
const currentProgress = ref(0)
const progressTimer = ref<any>(null)
const accumulatedTime = ref(0)
const resumeStartTime = ref<number>(0)



const processing = ref(false)

const handleConfirm = async () => {
  if (!localProcessResult.value.description) {
    ElMessage.warning('请输入处理结果说明')
    return
  }

  processing.value = true
  try {
    await emit('confirm', localProcessResult.value)
  } finally {
    processing.value = false
  }
}

onBeforeUnmount(() => {
  if (amrPlayer.value) {
    amrPlayer.value.stop()
  }
  clearInterval(progressTimer.value)
})

// 初始化
onBeforeMount(() => {
  amrPlayer.value = new BenzAMRRecorder()
})
const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = Math.floor(seconds % 60)
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
}
const startProgressTracking = (index: number) => {
  clearInterval(progressTimer.value)
  const duration = props.reportInfo.voiceFiles[index].shotTime

  progressTimer.value = setInterval(() => {
    if (!isPaused.value) {
      const elapsed = accumulatedTime.value + (Date.now() - resumeStartTime.value) / 1000
      currentProgress.value = Math.min((elapsed / duration) * 100, 100)
      const currentSeconds = Math.floor(elapsed)
      const clampedSeconds = Math.min(currentSeconds, duration)
      currentTime.value = formatTime(clampedSeconds) + ' / ' + formatTime(duration)

      if (currentProgress.value >= 100) {
        clearInterval(progressTimer.value)
      }
    }
  }, 100)
}

const stopPlayer = () => {
  amrPlayer.value.stop()
  amrPlayer.value = new BenzAMRRecorder()
  clearInterval(progressTimer.value)
  playingIndex.value = null
  isPaused.value = false
  currentProgress.value = 0
  currentTime.value = '00:00'
  accumulatedTime.value = 0
  resumeStartTime.value = 0
}

const playAudio = async (url: string, index: number) => {
  try {
    if (playingIndex.value === index) {
      if (amrPlayer.value.isPlaying()) {
        amrPlayer.value.pause()
        isPaused.value = true
        clearInterval(progressTimer.value)
        const played = (Date.now() - resumeStartTime.value) / 1000
        accumulatedTime.value += played
      } else if (isPaused.value) {
        amrPlayer.value.resume()
        isPaused.value = false
        resumeStartTime.value = Date.now()
        startProgressTracking(index)
      } else {
        stopPlayer()
      }
      return
    }

    if (playingIndex.value !== null && playingIndex.value !== index) {
      stopPlayer()
      await new Promise(resolve => setTimeout(resolve, 50))
    }

    playingIndex.value = index
    currentProgress.value = 0
    accumulatedTime.value = 0
    isPaused.value = false

    await amrPlayer.value.initWithUrl(url)
    amrPlayer.value.onEnded(() => {
      stopPlayer()
    })

    await amrPlayer.value.play()
    resumeStartTime.value = Date.now()
    startProgressTracking(index)
  } catch (error) {
    console.error('音频播放失败:', error)
    ElMessage.error('音频播放失败')
    stopPlayer()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(__props.reportInfo.reportTime), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(__props.reportInfo.creator), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(__props.reportInfo.orderNo), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, _toDisplayString(__props.reportInfo.targetNo), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(__props.reportInfo.earNo), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString(__props.reportInfo.note), 1)
          ]),
          (__props.reportInfo.voiceFiles?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.reportInfo.voiceFiles, (media, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "media-item"
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          link: "",
                          onClick: ($event: any) => (playAudio(__props.reportInfo.cosUrl + media.url, index))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(playingIndex.value === index ? (isPaused.value ? 'VideoPlay' : 'VideoPause') : 'VideoPlay')))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_el_progress, {
                              percentage: playingIndex.value === index ? currentProgress.value : 0,
                              "show-text": false,
                              "stroke-width": 4,
                              status: "success"
                            }, null, 8, ["percentage"])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            (playingIndex.value === index)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(currentTime.value), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString('00:00 / ' + formatTime(media.shotTime)), 1))
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("span", _hoisted_35, _toDisplayString(__props.reportInfo.phone), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("span", _hoisted_41, _toDisplayString(__props.processResult.compareResult), 1)
          ]),
          (__props.processResult.compareResult === '重复标的')
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("span", _hoisted_46, _toDisplayString(__props.processResult.duplicateInfo.orderNo), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", _hoisted_49, _toDisplayString(__props.processResult.duplicateInfo.targetNo), 1)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("span", _hoisted_52, _toDisplayString(__props.processResult.duplicateInfo.earNo), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("span", _hoisted_55, _toDisplayString(__props.processResult.duplicateInfo.similarity), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createVNode(_component_el_input, {
              modelValue: localProcessResult.value.description,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localProcessResult.value.description) = $event)),
              type: "textarea",
              rows: 4,
              placeholder: "请输入处理结果说明",
              disabled: __props.readonly
            }, null, 8, ["modelValue", "disabled"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createVNode(_component_el_button, {
        type: "primary",
        class: "confirm-btn",
        onClick: handleConfirm,
        loading: processing.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 完成处理 ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
}
}

})